<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.push('/main')" />

                <div class="finance-container">

                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('financePage.header') }}
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div>
                        <div class="all-payments-table">
                            <div class="all-payments-table__head">
                                <div class="row">
                                    <div>{{ $t('financePage.date') }}</div>
                                    <div>{{ $t('financePage.sum') }}</div>
                                    <div>{{ $t('financePage.tariff') }}</div>
                                    <div>{{ $t('financePage.period') }}</div>
                                    <div>{{ $t('financePage.method') }}</div>
                                </div>
                            </div>

                            <div class="all-payments-table__body">
                                <div v-for="payment in store.payments" class="row">
                                    <div>{{ getDateStringByTimestampWithTime(payment.date_pay) }}</div>
                                    <div>{{ (+payment.summa_opl).toFixed(2) }}</div>
                                    <div>
                                        <div v-if="payment.name">
                                            {{ payment.name }}<br>{{ payment.speed }} {{ $t('financePage.speed') }}
                                        </div>
                                        <div v-else>
                                            Поповнення<br>балансу
                                        </div>
                                    </div>
                                    <div>
                                        <div v-if="payment.from">
                                            {{ getDateStringByTimestamp(+payment.from) }}  {{ getDateStringByTimestamp(+payment.to) }}
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </div>
                                    <div>{{ parsePaymentType(payment.pay_system) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import '@/assets/scss/finance-page.scss';

import { useMainStore } from '@/store/mainStore';

import { getDateStringByTimestampWithTime, getDateStringByTimestamp } from '@/services/utils';

import { useI18n } from 'vue-i18n';

export default {
    name: "FinanceView",

    setup() {
        const store = useMainStore();
        const { t } = useI18n();

        const parsePaymentType = (type) => {
            switch (type) {
                case 'balance':
                    return t('financePage.balance');
                case 'portmone':
                    return t('financePage.cabinet');
                case 'kassa':
                    return t('financePage.cashbox');
                default:
                    return '?';
            }
        };

        return {
            store,
            parsePaymentType,
            getDateStringByTimestampWithTime: getDateStringByTimestampWithTime,
            getDateStringByTimestamp: getDateStringByTimestamp
        };
    }
}
</script>
